import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokenValid, setTokenValid] = useState(true);

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  useEffect(() => {
    // Verificar se token e email estão presentes na URL
    if (!token || !email) {
      setTokenValid(false);
      setError('Link inválido. Por favor, solicite uma nova recuperação de senha.');
    }
  }, [token, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    // Validações
    if (password.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres.');
      setLoading(false);
      return;
    }

    if (password !== passwordConfirmation) {
      setError('A confirmação de senha não coincide.');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/auth/reset-password', {
        token,
        email,
        password,
        password_confirmation: passwordConfirmation
      });

      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.message || 'Erro ao redefinir senha.');
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || 'Erro ao processar solicitação.');
      } else {
        setError('Erro de conexão. Verifique se o servidor está rodando.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!tokenValid) {
    return (
      <div className="login-body">
        <div className="login-background"></div>

        <div className="login-container-wrapper">
          <div className="alert alert-danger" role="alert">
            {error}
          </div>

          <div className="text-center mt-4">
            <Link to="/forgot-password" className="btn btn-modern btn-modern-primary">
              Solicitar Nova Recuperação
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-body">
      <div className="login-background"></div>

      <div className="login-container-wrapper">
        <h2 className="text-center mb-4" style={{ fontSize: '1.5rem', color: '#1e293b' }}>
          Redefinir Senha
        </h2>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {success ? (
          <div className="alert alert-success" role="alert">
            <h5 className="alert-heading">Senha redefinida com sucesso!</h5>
            <p className="mb-0">
              Sua senha foi atualizada. Você já pode fazer login com sua nova senha.
            </p>
            <div className="mt-3">
              <Link to="/login" className="btn btn-modern btn-modern-primary">
                Ir para o Login
              </Link>
            </div>
          </div>
        ) : (
          <>
            <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>
              Digite sua nova senha abaixo.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-group-modern">
                <label>Nova Senha</label>
                <input
                  type="password"
                  className="form-control-modern"
                  placeholder="Digite sua nova senha (mínimo 6 caracteres)"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoFocus
                  minLength={6}
                />
              </div>

              <div className="form-group-modern">
                <label>Confirmar Senha</label>
                <input
                  type="password"
                  className="form-control-modern"
                  placeholder="Confirme sua nova senha"
                  value={passwordConfirmation}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  required
                  minLength={6}
                />
              </div>

              <button
                type="submit"
                className="btn-modern btn-modern-primary w-100 mt-3"
                style={{ padding: '12px', fontSize: '1rem' }}
                disabled={loading}
              >
                {loading ? 'Redefinindo...' : 'Redefinir Senha'}
              </button>
            </form>

            <div className="text-center mt-4">
              <Link to="/login" style={{ fontSize: '0.9rem', color: '#64748b' }}>
                Voltar para o Login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
